import { typeInfo } from "../../../../constants/typeInfo";

const TypeBox = ({ type, isMobile }) => {
  return (
    <div
      style={{
        fontSize: isMobile ? "12px" : "16px",
        padding: isMobile ? "4px 20px" : "8px 30px",
        color: "#FFF",
        backgroundColor: typeInfo[type].color,
        borderRadius: "5px",
      }}
    >
      {typeInfo[type].text}
    </div>
  );
};

export default TypeBox;
